import postscribe from 'postscribe';
import History from 'history.js/history';
import History from 'history.js/history.adapter.ender';

var History = window.History;

(function($) {
    $.fn.infinity = function(options) {
        var elm = $(this);
        var elm_id = $(this).attr('id');
        var defaults = {
            item: ".item",
            urls: [],
            loading: true,
            analytics: false,
            isAjax: false,
            loadingText: 'Loading...',
            postscribe: false,
            timeOut: 1, // second sleep
            position: 'bottom',
            onHistoryChange: function() {},
            onAjaxSuccess: function() {}
        }
        var settings = $.extend( {}, defaults, options );
        var currentScroll = 0;
        var elementHeight = 0;
        var lastElement = $('#'+ elm_id).find(settings.item).last();
        var ajaxBusy, scrollBusy = false;

        function run() {
            createLoading();
            scroller();
            settings.urls.push($('#'+ elm_id).find(settings.item).first().attr('data-url'));
        }

        function scroller() {
            $(window).scroll(function() {
                elementHeight = $('#'+ elm_id).prop('scrollHeight');
                if(settings.position == 'bottom')
                    currentScroll = $(window).scrollTop() + window.innerHeight;
                else if(settings.position == 'top')
                    currentScroll = $(window).scrollTop() + 50;


                if(settings.position == 'bottom')
                {
                    if(currentScroll >= elementHeight) {
                        if(!scrollBusy) {
                            scrollBusy = true;
                            getAjaxContent();
                            scrollBusy = false;
                        }
                    }
                }
                else if(settings.position == 'top')
                {
                    if(currentScroll >= elementHeight - 1090) {
                        if(!scrollBusy) {
                            scrollBusy = true;
                            getAjaxContent();
                            scrollBusy = false;
                        }
                    }
                }

                if(!scrollBusy) {
                    scrollBusy = true;
                    pushUrl();
                    scrollBusy = false;
                }
            });
        }

        function getAjaxContent() {
            if(settings.isAjax && !ajaxBusy) {
                ajaxBusy = true;
                var nextUrl = lastElement.attr('data-next');

                if(window.segRecommendReady) {
                    if(window.segRecommendedProductUrl.indexOf('-haberi-'))
                    {
                        nextUrl = window.segRecommendedProductUrl;
                        segScrollComplete();
                    }
                }

                if(nextUrl != '')
                {
                    showLoading();
                    $.ajax({
                        cache: true,
                        type: 'GET',
                        url: nextUrl,
                        data: 'history=1',
                        dataType: 'html',
                        success: function(response) {
                            var response = response;
                            if(response != '') {
                                if(settings.timeOut > 0) {
                                    setTimeout(function() { setAjaxContent(response) }, settings.timeOut * 1000);
                                } else {
                                    setAjaxContent(response);
                                }
                            }
                            lastElement = $('#'+ elm_id).find(settings.item).last();
                        }
                    });
                }
            }
        }

        function setAjaxContent(response)
        {
            if(settings.postscribe) {
                postscribe('#'+ elm_id, response);
            } else {
                $('#'+ elm_id).append(response);
            }

            hideLoading();
            ajaxBusy = false;
            pushUrl();
            lastElement = $('#'+ elm_id).find(settings.item).last();
            settings.onAjaxSuccess(lastElement);
        }

        function createLoading() {
            return $('#'+ elm_id).after('<div class="history_loading" style="display:none">'+ settings.loadingText +'</div>');
        }

        function showLoading() {
            return $('.history_loading').show();
        }

        function hideLoading() {
            return $('.history_loading').hide();
        }

        function pushUrl() {
            var itemElement;
            var elementScrollTop = $('#'+ elm_id).offset().top;

            $('#'+ elm_id).find(settings.item).each(function(item) {
                var itemTop = $(this).position().top;
                var itemHeight = $(this).height();
                if ((itemTop + elementScrollTop) <= currentScroll && currentScroll <= (itemTop + itemHeight + elementScrollTop)) {
                    itemElement = $(this);
                }
            });
            var url = $(itemElement).attr('data-url');
            var title = $(itemElement).attr('data-title');
            if (url != '' && url != null && url != undefined) {
                var currentUrl = window.location.href;
                if(currentUrl != url) {
                    historyPushState(title, url);
                    setPageViewAnalytics(url, title);
                    settings.onHistoryChange($(itemElement));
                }
            }
        }

        function historyPushState(title, url) {
            var stateData = {
                type: "article",
                url: url
            };

            if($.inArray(url, settings.urls) < 0) {
                settings.urls.push(url);
                History.pushState(stateData, title, url);
                //History.replaceState(stateData, title, url);
            } else {
                History.replaceState(stateData, title, url);
            }
            document.title = title;
        }

        function setPageViewAnalytics(url, title) {
            if(settings.analytics) {
                var url = url;
                url = url.replace(window.location.protocol + "//" + window.location.hostname, "");
                //_gaq.push(['_trackPageview', url]);
                ga('send', 'pageview', url);
            }
        }

        return run();
    }
})( jQuery );


//////////////////
// WEBPACK FOOTER
// ./node_modules/@bilginpro/infinity.js/index.js
// module id = fa8d
// module chunks = 0 1 2 3